var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1 9.66818V9.56818L4.39223 29.1H25.6105C26.0687 29.1 26.5225 29.01 26.9458 28.8352C27.3691 28.6604 27.7538 28.4041 28.0778 28.0811C28.4019 27.758 28.659 27.3745 28.8343 26.9524C29.0097 26.5302 29.1 26.0778 29.1 25.6209V9.66818ZM27.7478 10.9168V25.6207C27.7472 26.1855 27.5218 26.727 27.1212 27.1265C26.7205 27.5259 26.1772 27.7507 25.6104 27.7513H4.39227C3.82523 27.7507 3.28163 27.526 2.88052 27.1266C2.47946 26.7272 2.25355 26.1857 2.25215 25.6208V10.9168H27.7478Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.9 10.7367V10.8367H1H29H29.1V10.7367V5.87768C29.1 4.95463 28.7324 4.0694 28.078 3.41654C27.4237 2.76369 26.5362 2.39661 25.6106 2.39588L25.6105 2.49588V2.39588H4.39215C3.46607 2.39588 2.57787 2.76264 1.92294 3.41557C1.268 4.06851 0.9 4.95415 0.9 5.87768V10.7367ZM27.1213 4.37109C27.5219 4.77097 27.7472 5.31276 27.7478 5.8778L25.6104 3.74452C26.1774 3.74591 26.7207 3.97125 27.1213 4.37109Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28669 6.54818V1.63041C7.28669 1.4366 7.20945 1.25078 7.07208 1.11383C6.93471 0.97688 6.74847 0.9 6.55434 0.9C6.36021 0.9 6.17397 0.97688 6.0366 1.11383C5.89923 1.25078 5.822 1.4366 5.822 1.63041V6.54818C5.822 6.74199 5.89923 6.92781 6.0366 7.06477C6.17397 7.20171 6.36021 7.27859 6.55434 7.27859C6.74847 7.27859 6.93471 7.20171 7.07208 7.06477C7.20945 6.92781 7.28669 6.74199 7.28669 6.54818Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9189 6.55468L12.9191 6.5547V6.54817V1.63041H12.8191L12.9189 1.62389C12.9067 1.43801 12.8241 1.26375 12.6879 1.13647C12.5516 1.0092 12.372 0.938422 12.1854 0.938422C11.9988 0.938422 11.8191 1.0092 11.6829 1.13647C11.5467 1.26375 11.464 1.43801 11.4519 1.62389L11.4517 1.62388V1.63041V6.54817H11.4515L11.4519 6.55468C11.464 6.74057 11.5467 6.91482 11.6829 7.0421C11.8191 7.16938 11.9988 7.24015 12.1854 7.24015C12.372 7.24015 12.5516 7.16938 12.6879 7.0421C12.8241 6.91482 12.9067 6.74057 12.9189 6.55468Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5485 6.54818V1.63041C18.5485 1.4366 18.4713 1.25078 18.3339 1.11383C18.1966 0.97688 18.0103 0.9 17.8162 0.9C17.6221 0.9 17.4358 0.97688 17.2984 1.11383C17.1611 1.25078 17.0838 1.4366 17.0838 1.63041V6.54818C17.0838 6.74199 17.1611 6.92781 17.2984 7.06477C17.4358 7.20171 17.6221 7.27859 17.8162 7.27859C18.0103 7.27859 18.1966 7.20171 18.3339 7.06477C18.4713 6.92781 18.5485 6.74199 18.5485 6.54818Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1802 6.55468L24.1804 6.5547V6.54817V1.63041H24.0804L24.1802 1.62389C24.1681 1.43801 24.0855 1.26375 23.9492 1.13647C23.813 1.0092 23.6333 0.938422 23.4467 0.938422C23.2601 0.938422 23.0805 1.0092 22.9443 1.13647C22.808 1.26375 22.7254 1.43801 22.7133 1.62389L22.713 1.62388V1.63041V6.54817H22.7128L22.7133 6.55468C22.7254 6.74057 22.808 6.91482 22.9443 7.0421C23.0805 7.16938 23.2601 7.24015 23.4467 7.24015C23.6333 7.24015 23.813 7.16938 23.9492 7.0421C24.0855 6.91482 24.1681 6.74057 24.1802 6.55468Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3318 15.306H11.2318V15.406V17.9571V18.0571H11.3318H13.8906H13.9906V17.9571V15.406V15.306H13.8906H11.3318Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1091 15.306H16.0091V15.406V17.9571V18.0571H16.1091H18.668H18.768V17.9571V15.406V15.306H18.668H16.1091Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8865 15.306H20.7865V15.406V17.9571V18.0571H20.8865H23.4453H23.5453V17.9571V15.406V15.306H23.4453H20.8865Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55444 19.3049H6.45444V19.4049V21.9559V22.0559H6.55444H9.1133H9.2133V21.9559V19.4049V19.3049H9.1133H6.55444Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3318 19.3049H11.2318V19.4049V21.9559V22.0559H11.3318H13.8906H13.9906V21.9559V19.4049V19.3049H13.8906H11.3318Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1091 19.3049H16.0091V19.4049V21.9559V22.0559H16.1091H18.668H18.768V21.9559V19.4049V19.3049H18.668H16.1091Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8865 19.3049H20.7865V19.4049V21.9559V22.0559H20.8865H23.4453H23.5453V21.9559V19.4049V19.3049H23.4453H20.8865Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55444 23.3037H6.45444V23.4037V25.9548V26.0548H6.55444H9.1133H9.2133V25.9548V23.4037V23.3037H9.1133H6.55444Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3318 23.3037H11.2318V23.4037V25.9548V26.0548H11.3318H13.8906H13.9906V25.9548V23.4037V23.3037H13.8906H11.3318Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1091 23.3037H16.0091V23.4037V25.9548V26.0548H16.1091H18.668H18.768V25.9548V23.4037V23.3037H18.668H16.1091Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.8f0cae8b0b8f8498f7ccc1864afff5ed.svg";
export { ForwardRef as ReactComponent };